import sdl from '@jds/react-generated-sdl/JDSMegaMenuInternal';
import type { JDSMegaMenuInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSMegaMenuInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { open = false, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { open, ...rest },
    'JDSMegaMenuInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const MegaMenuInternal = withLogic(
  Component
) as React.FC<JDSMegaMenuInternalProps> & { slotName?: string };

MegaMenuInternal.displayName = 'MegaMenuInternal';
MegaMenuInternal.slotName = 'jds_mega_menu_internal';

export { MegaMenuInternal, type JDSMegaMenuInternalProps };
